export default __webpack_public_path__ + "static/media/mastercard.a5ad7303.png";